import { useCallback, useState } from "react";

interface UseControllableOpenOptions {
  value?: boolean;
  defaultValue: boolean;
  disabled?: boolean;
  onChange?: (open: boolean) => void;
}

export function useControllableOpen({
  value,
  defaultValue,
  disabled = false,
  onChange,
}: UseControllableOpenOptions) {
  const [uncontrolledValue, setUncontrolledValue] = useState(defaultValue);
  const isControlled = value !== undefined;
  const resolvedOpen = isControlled ? value : uncontrolledValue;

  const setOpen = useCallback(
    (nextOpen: boolean) => {
      if (nextOpen && disabled) return;
      if (!isControlled) setUncontrolledValue(nextOpen);
      onChange?.(nextOpen);
    },
    [disabled, isControlled, onChange],
  );

  return { resolvedOpen: disabled ? false : resolvedOpen, setOpen } as const;
}
